import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"flag-2, priority"} maskId="square-filled-radius-0-stroke-1-IconFlag2"><path d="M11.8661 15.6481C9.54805 15.0036 7.40789 14.4226 5 15.4849V21.9997H4V3.24355L4.27983 3.10631C7.16419 1.69165 9.72041 2.40241 12.0864 3.06028L12.1339 3.07349C14.5414 3.74278 16.7569 4.34368 19.2798 3.10631L20 2.75309V15.478L19.7202 15.6152C16.8358 17.0299 14.2796 16.3191 11.9136 15.6613L11.8661 15.6481Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFlag2;
